

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETALLAPPRAISALYEAR= createAsyncThunk(
  "getAllAppraisalYears/getAllAppraisalYears",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllAppraisalYearsSlice = createSlice({
  name: "getAllAppraisalYearsSlice",
  initialState: {
    getAllAppraisalYears: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllAppraisalYears: (state) => {
        state.getAllAppraisalYears.loading = false
        state.getAllAppraisalYears.error = false
        state.getAllAppraisalYears.data = []
        state.getAllAppraisalYears.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLAPPRAISALYEAR.fulfilled, (state, action) => {
      state.getAllAppraisalYears = {
        ...state.getAllAppraisalYears,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPRAISALYEAR.pending, (state, action) => {
      state.getAllAppraisalYears = {
        ...state.getAllAppraisalYears,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLAPPRAISALYEAR.rejected, (state, action) => {
      state.getAllAppraisalYears = {
        ...state.getAllAppraisalYears,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllAppraisalYearsAction = {
    GETALLAPPRAISALYEAR,
};

export { getAllAppraisalYearsAction };
export default getAllAppraisalYearsSlice.reducer;
export const {setInitialStateOfgetAllAppraisalYears} = getAllAppraisalYearsSlice.actions
